import getFieldsFromForm from './getFieldsFromForm';

// Questions of a survey, as opposed to the contact details of the reader
const QUESTION_TYPES = ['buttons', 'radios', 'select', 'text', 'table'];

/**
 * Whether a form can be answered one question at a time, like a survey. A form asking for
 * anything else (email, phone, birth date...) keeps the full form.
 */
export default function canAnswerFormBySteps(form: Form | null): boolean {
    const fields = form !== null ? getFieldsFromForm(form) : [];
    return fields.length > 0 && fields.every(({ type = null }) => QUESTION_TYPES.includes(type));
}
